import React from "react";
import { Link } from "react-router-dom";
import { getAllCountries } from "../data/countriesDatabase";
import StudyBg from "../assets/img/studyBg.png"
import Europe from "../assets/europe.svg"
import Africa from "../assets/africa.svg"
import Asia from "../assets/asia.svg"
import NorthA from "../assets/northAmerica.svg"

function DestinationsPage() {
  const countries = getAllCountries();

  return (
    <div className="container mx-auto">
       <div className="block bg-white h-[130px]"></div>
      <div className="container mx-auto">
      <div className="relative w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
      <img
        src={StudyBg}
        alt="Background"
        className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
      />

      <div className="absolute inset-0 flex items-center justify-center">
        <h1 className="text-white text-3xl md:text-6xl font-bold text-center">
        Study  Destinations
        </h1>
      </div>
    </div>

        <div className="flex flex-wrap justify-center md:justify-start gap-6 my-16">
          {countries.map((country) => (
            <div className="flex flex-col justify-between items-center gap-2 w-[300px] p-1 mb-6 bg-white border border-gray-neutral rounded-3xl ">
              <Link
                  to={`/destination/${country.code}`}>
              <div className="relative group overflow-hidden rounded-3xl">
                <img
                  src={country.thumbnail}
                  alt="destinations"
                  width={300}
                  className="min-h-[286px] object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute bg-secondary rounded-full px-3 py-1 top-2 left-2 text-white">
                  {country.name}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 p-4 text-white">
                  
                </div>
              </div>
                {/* <img src={country.flag} alt="check" width={24} height={24} className="absolute bottom-3 right-3"/> */}
            
                <div className="absolute bottom-3 right-3 text-3xl"> {country.flag}</div>
              </div>
              </Link>
              <p className="text-base px-4 opacity-80 py-3">
                {" "}
                {country.description}
              </p>
              <Link
                to={`/destination/${country.code}`}
                className="uppercase border group gap-3 flex border-primary text-primary mb-3 py-3 px-8 rounded-full hover:bg-gray-cool hover:text-white duration-500"
              >
                See destination
                <svg
                  className=""
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.00024 13.5L18.5862 13.5L13.2932 18.793C13.1987 18.8855 13.1234 18.9958 13.0718 19.1176C13.0202 19.2393 12.9932 19.3701 12.9925 19.5024C12.9917 19.6347 13.0173 19.7658 13.0675 19.8881C13.1178 20.0104 13.1919 20.1216 13.2854 20.2151C13.3789 20.3086 13.4901 20.3826 13.6124 20.4329C13.7348 20.4832 13.8659 20.5087 13.9981 20.5079C14.1304 20.5071 14.2612 20.4802 14.383 20.4285C14.5047 20.3769 14.615 20.3016 14.7075 20.207L21.7075 13.207C21.895 13.0195 22.0003 12.7652 22.0003 12.5C22.0003 12.2348 21.895 11.9805 21.7075 11.793L14.7075 4.793C14.6147 4.69996 14.5045 4.62618 14.3831 4.57589C14.2617 4.52561 14.1316 4.49982 14.0002 4.5C13.8025 4.50004 13.6092 4.55871 13.4448 4.6686C13.2804 4.77848 13.1522 4.93465 13.0766 5.11735C13.0009 5.30005 12.9811 5.50108 13.0197 5.69503C13.0582 5.88899 13.1534 6.06715 13.2932 6.207L18.5862 11.5L3.00024 11.5C2.73502 11.5 2.48067 11.6054 2.29313 11.7929C2.10559 11.9804 2.00024 12.2348 2.00024 12.5C2.00024 12.7652 2.10559 13.0196 2.29313 13.2071C2.48067 13.3946 2.73502 13.5 3.00024 13.5Z"
                    fill="#1F2041"
                    className="group-hover:fill-white"
                  />
                </svg>
              </Link>
            </div>
          ))}
        </div>

        <div>
          <h1 className="text-primary text-4xl capitalize ms-6 md:ms-0">Explore by continents</h1>
          <div className="mt-12 flex flex-wrap">
            <a href="/continents" className="my-2 flex flex-col items-center w-[300px] border border-gray-neutral rounded-3xl mx-auto p-4 hover:shadow-lg duration-500">
              <img src={Europe} alt="europe" />
              <p className="text-2xl font-semibold mt-4 text-primary">Europe</p>
            </a>
            <a href="/continents" className="my-2 flex flex-col items-center w-[300px] border border-gray-neutral rounded-3xl mx-auto p-4 hover:shadow-lg duration-500">
              <img src={NorthA} alt="North America" />
              <p className="text-2xl font-semibold mt-4 text-primary">North America</p>
            </a>
            <a href="/continents" className="my-2 flex flex-col items-center w-[300px] border border-gray-neutral rounded-3xl mx-auto p-4 hover:shadow-lg duration-500">
              <img src={Asia} alt="Asia" />
              <p className="text-2xl font-semibold mt-4 text-primary">Asia</p>
            </a>
            <a href="/continents" className="my-2 flex flex-col items-center w-[300px] border border-gray-neutral rounded-3xl mx-auto p-4 hover:shadow-lg duration-500">
              <img src={Africa} alt="Africa" />
              <p className="text-2xl font-semibold mt-4 text-primary">Africa</p>
            </a>
           
          
          </div>
        </div>

       
      </div>
    </div>
  );
}

export default DestinationsPage;
